import React, {useState, useEffect} from 'react'

import Testimonial from '../assets/image/testimonial-3.jpg'
import axios from 'axios';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Button from '../components/Button';


function ReviewSlide() {
    const [ratting, setRatting] = useState([]);

     useEffect(() => {
        axios.get('https://profile.flicknlink.com/api/ratting')
        .then(response => {
            setRatting(response.data);
        })
        .catch(err => {
        });
    },
    []);

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true, // Pause on hover
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <div>
            <section className='Testimonial'>
                <div className='container'>
                    <div className='grid md:grid-cols-2 grid-cols-1 items-center justify-between lg:gap-5 md:gap-10 gap-5'>
                        <div>
                            <h2>What Our Customers Say!</h2>
                        </div>
                        <div className='md:mr-0 md:ml-auto'>
                            <Button link='/review'  className='dark-btn' name='More Review' />
                        </div>
                    </div>
                </div>
                    <div className='items-center md:mt-20 mt-12 max-w-full overflow-hidden px-2'>
                        <Slider {...settings}>
                            {ratting.map((review, index) => (
                                <ReviewCard key={index} data={review}/>
                            ))}
                        </Slider>
                    </div>
            </section>
        </div>
    )
}

function ReviewCard(data) {
    var users = data.data.user_data;
    return(
        <>
            <div className='border-2 border-bgprimary rounded-xl p-5'>
                <div className='flex justify-start items-center gap-3 mb-4'>
                    <img className='aspect-square border-2 w-12 border-bgprimary rounded-full overflow-hidden' src={Testimonial} alt='' />
                    <div>
                    {Object.entries(users).map(([key, value]) => (
                        key === 'name' ? (
                            <p className='font-bold mb-1'>{data.data.user_data.name}</p>
                        ) : null
                    ))}
                    </div>
                </div>
                <div>
                    <p className='clamp-2-lines'>{data.data.comment}</p>
                </div>
            </div>
        </>
    )
}

export default ReviewSlide;
